import FilterRegister from "../../../../components/filter/register-basic";
import reqContaTipo from "../../../../services/reqMultiTenant/reqContaTipo";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";

const MainRegisterTypeAccount = () => {
	const options = {
		id: "id_conta_tipo", //usado para saber qual field usar para atualizar
		ident: "typeaccount", //usado para definir os event listners
		identFilter: "filterTypeAccount", //usado para definir os event listners
		title: "Conta Tipo",
		subTitle: "Cadastro",
		tableColumns: [
			{ key: "nome", label: "Categoria", align: "left" },
			{ key: "obs", label: "Observação", align: "left" },
			{
				key: "tipo",
				label: "Aonde se Encaixa",
				align: "left",
				format: "map",
				map: { E: "Conta Entrada", S: "Conta Saída", T: "Todos" },
			},
			{ key: "empty2", label: "", align: "left" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Categoria", value: "nome" }],
	};

	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData; //contem active que retorna true ou false

		const responseComplement = await reqContaTipo.listPaginate(param, paramValue, active, newPage);

		return responseComplement;
	};

	const fetchID = async (currentId) => {
		const responseComplement = await reqContaTipo.listID(currentId);

		return responseComplement;
	};

	const insert = async (data) => {
		const response = await reqContaTipo.insert(data);

		return response;
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterTypeAccount;
